import React, { useState } from "react"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"
import CenterModal from "components/Common/CenterModal"
import InviteForm from "components/ParentingSpace/InviteMemberForm"
import { getParentingSpaceUserList } from "helpers/fakebackend_helper"
import { useQuery } from "react-query"
import { useLocalStorage } from "hooks/userLocalStorage"
import { format } from "prettier"
import UserAvatarFromName from "components/Common/UserAvatarFromName"

const SocialSource = () => {

  const { data, isLoading } = useQuery('space_user_list', getParentingSpaceUserList, {
    staleTime: 120000,
      refetchOnWindowFocus: false,
    });

    const { getAuthUserID } = useLocalStorage();
    const authUserID = getAuthUserID();
    // const authUserName = getAuthUserName();
  

  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  const myData = data?.users?.find(user => user.id === authUserID);
  const otherUsers = data?.users?.filter(user => user.id !== authUserID).slice(0, 3);
 
  return (
    <React.Fragment>
      <Card
  
       style={{  height: '550px' }}
       >
        <CardBody>
          <CardTitle className="mb-4">Space Members</CardTitle>
          <div className="text-center">
            <div className="avatar-sm mx-auto mb-4">
              {/* <img src={data?.users?.find(user => user.id === authUserID)?.profile_pic || "https://randomuser.me/api/portraits/thumb/men/75.jpg"} alt="Avatar" className="rounded-circle avatar-sm mx-auto mb-4" /> */}
              {myData?.profile_pic ? (
                <img src={myData?.profile_pic} alt="Avatar" className="rounded-circle avatar-sm mx-auto mb-4" />
              ) : (
                <UserAvatarFromName name={myData?.name} size="sm" />
              )}
            </div>
            {/* <p className="font-16 text-muted mb-2">{myData?.email}</p> */}
            <h5>
              <Link to="#" className="text-dark font-size-14">
                {myData?.name}
              </Link>
            </h5>
            <p className="text-muted font-size-9 ">
              {myData?.pivot.role}
            </p>
          </div>

          <div className="mb-4 mx-auto text-center">
            <p className="text-muted">Welcome to the Parenting Space Community! Connect with fellow members, stay updated on upcoming events, and check out new messages and completed activities.</p>
          </div>
          <Row className="mt-4">
            {otherUsers?.map((user, key) => (
              <Col xs="4" key={"_li_" + key}>
                <div className="social-source text-center mt-3">
                  <div className="avatar-xs mx-auto mb-3">

                    <span>
                      {user.profile_pic ? (
                        <img src={user.profile_pic} alt="Avatar" className="rounded-circle avatar-xs mx-auto mb-4" />
                      ) : (
                        <UserAvatarFromName name={user.name} size="xs" />
                      )}

                    </span>
                  </div>
                  <h6 className="font-size-12">{user.name}</h6>
                  <p className="font-size-9 text-muted mb-0">{user.pivot.role} </p>
                </div>
              </Col>
            ))}
          </Row>
          <Row className="row-reverse" style={{ marginTop: '50px' }}>
            <Col  className="text-right">
              <Link to="/member-list" className="text-primary font-16">
                Show all members<i className="mdi mdi-chevron-right"></i>
              </Link>
            </Col>
            <Col xs="6" className="text-center">
              <div className="text-center">
                <button style={{ backgroundColor: "#2F8C47" }} className="btn btn-primary font-16" onClick={() => setModalOpen(true)}>
                  Invite User
                </button>
              </div>
              <CenterModal isOpen={modalOpen}
                toggle={toggleModal}
               title="Invite User">
                <InviteForm  setModal={setModalOpen}/>
              </CenterModal>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default SocialSource
